module.exports = __webpack_public_path__ + "assets/img/coolstorybro.68a7781fc6e13ce5aaa86c763689a486.png";